/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.proto = (function() {

    /**
     * Namespace proto.
     * @exports proto
     * @namespace
     */
    var proto = {};

    proto.ValidationError = (function() {

        /**
         * Properties of a ValidationError.
         * @memberof proto
         * @interface IValidationError
         * @property {string|null} [code] ValidationError code
         * @property {string|null} [msg] ValidationError msg
         * @property {Array.<proto.ValidationError.IFieldViolation>|null} [fieldViolations] ValidationError fieldViolations
         */

        /**
         * Constructs a new ValidationError.
         * @memberof proto
         * @classdesc Represents a ValidationError.
         * @implements IValidationError
         * @constructor
         * @param {proto.IValidationError=} [properties] Properties to set
         */
        function ValidationError(properties) {
            this.fieldViolations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ValidationError code.
         * @member {string} code
         * @memberof proto.ValidationError
         * @instance
         */
        ValidationError.prototype.code = "";

        /**
         * ValidationError msg.
         * @member {string} msg
         * @memberof proto.ValidationError
         * @instance
         */
        ValidationError.prototype.msg = "";

        /**
         * ValidationError fieldViolations.
         * @member {Array.<proto.ValidationError.IFieldViolation>} fieldViolations
         * @memberof proto.ValidationError
         * @instance
         */
        ValidationError.prototype.fieldViolations = $util.emptyArray;

        /**
         * Creates a new ValidationError instance using the specified properties.
         * @function create
         * @memberof proto.ValidationError
         * @static
         * @param {proto.IValidationError=} [properties] Properties to set
         * @returns {proto.ValidationError} ValidationError instance
         */
        ValidationError.create = function create(properties) {
            return new ValidationError(properties);
        };

        /**
         * Encodes the specified ValidationError message. Does not implicitly {@link proto.ValidationError.verify|verify} messages.
         * @function encode
         * @memberof proto.ValidationError
         * @static
         * @param {proto.IValidationError} message ValidationError message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ValidationError.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && message.hasOwnProperty("code"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.code);
            if (message.msg != null && message.hasOwnProperty("msg"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.msg);
            if (message.fieldViolations != null && message.fieldViolations.length)
                for (var i = 0; i < message.fieldViolations.length; ++i)
                    $root.proto.ValidationError.FieldViolation.encode(message.fieldViolations[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ValidationError message, length delimited. Does not implicitly {@link proto.ValidationError.verify|verify} messages.
         * @function encodeDelimited
         * @memberof proto.ValidationError
         * @static
         * @param {proto.IValidationError} message ValidationError message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ValidationError.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ValidationError message from the specified reader or buffer.
         * @function decode
         * @memberof proto.ValidationError
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {proto.ValidationError} ValidationError
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ValidationError.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.proto.ValidationError();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.code = reader.string();
                    break;
                case 2:
                    message.msg = reader.string();
                    break;
                case 3:
                    if (!(message.fieldViolations && message.fieldViolations.length))
                        message.fieldViolations = [];
                    message.fieldViolations.push($root.proto.ValidationError.FieldViolation.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ValidationError message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof proto.ValidationError
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {proto.ValidationError} ValidationError
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ValidationError.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ValidationError message.
         * @function verify
         * @memberof proto.ValidationError
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ValidationError.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isString(message.code))
                    return "code: string expected";
            if (message.msg != null && message.hasOwnProperty("msg"))
                if (!$util.isString(message.msg))
                    return "msg: string expected";
            if (message.fieldViolations != null && message.hasOwnProperty("fieldViolations")) {
                if (!Array.isArray(message.fieldViolations))
                    return "fieldViolations: array expected";
                for (var i = 0; i < message.fieldViolations.length; ++i) {
                    var error = $root.proto.ValidationError.FieldViolation.verify(message.fieldViolations[i]);
                    if (error)
                        return "fieldViolations." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ValidationError message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof proto.ValidationError
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {proto.ValidationError} ValidationError
         */
        ValidationError.fromObject = function fromObject(object) {
            if (object instanceof $root.proto.ValidationError)
                return object;
            var message = new $root.proto.ValidationError();
            if (object.code != null)
                message.code = String(object.code);
            if (object.msg != null)
                message.msg = String(object.msg);
            if (object.fieldViolations) {
                if (!Array.isArray(object.fieldViolations))
                    throw TypeError(".proto.ValidationError.fieldViolations: array expected");
                message.fieldViolations = [];
                for (var i = 0; i < object.fieldViolations.length; ++i) {
                    if (typeof object.fieldViolations[i] !== "object")
                        throw TypeError(".proto.ValidationError.fieldViolations: object expected");
                    message.fieldViolations[i] = $root.proto.ValidationError.FieldViolation.fromObject(object.fieldViolations[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ValidationError message. Also converts values to other types if specified.
         * @function toObject
         * @memberof proto.ValidationError
         * @static
         * @param {proto.ValidationError} message ValidationError
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ValidationError.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.fieldViolations = [];
            if (options.defaults) {
                object.code = "";
                object.msg = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.msg != null && message.hasOwnProperty("msg"))
                object.msg = message.msg;
            if (message.fieldViolations && message.fieldViolations.length) {
                object.fieldViolations = [];
                for (var j = 0; j < message.fieldViolations.length; ++j)
                    object.fieldViolations[j] = $root.proto.ValidationError.FieldViolation.toObject(message.fieldViolations[j], options);
            }
            return object;
        };

        /**
         * Converts this ValidationError to JSON.
         * @function toJSON
         * @memberof proto.ValidationError
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ValidationError.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        ValidationError.FieldViolation = (function() {

            /**
             * Properties of a FieldViolation.
             * @memberof proto.ValidationError
             * @interface IFieldViolation
             * @property {string|null} [field] FieldViolation field
             * @property {string|null} [code] FieldViolation code
             * @property {string|null} [param] FieldViolation param
             * @property {string|null} [msg] FieldViolation msg
             */

            /**
             * Constructs a new FieldViolation.
             * @memberof proto.ValidationError
             * @classdesc Represents a FieldViolation.
             * @implements IFieldViolation
             * @constructor
             * @param {proto.ValidationError.IFieldViolation=} [properties] Properties to set
             */
            function FieldViolation(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FieldViolation field.
             * @member {string} field
             * @memberof proto.ValidationError.FieldViolation
             * @instance
             */
            FieldViolation.prototype.field = "";

            /**
             * FieldViolation code.
             * @member {string} code
             * @memberof proto.ValidationError.FieldViolation
             * @instance
             */
            FieldViolation.prototype.code = "";

            /**
             * FieldViolation param.
             * @member {string} param
             * @memberof proto.ValidationError.FieldViolation
             * @instance
             */
            FieldViolation.prototype.param = "";

            /**
             * FieldViolation msg.
             * @member {string} msg
             * @memberof proto.ValidationError.FieldViolation
             * @instance
             */
            FieldViolation.prototype.msg = "";

            /**
             * Creates a new FieldViolation instance using the specified properties.
             * @function create
             * @memberof proto.ValidationError.FieldViolation
             * @static
             * @param {proto.ValidationError.IFieldViolation=} [properties] Properties to set
             * @returns {proto.ValidationError.FieldViolation} FieldViolation instance
             */
            FieldViolation.create = function create(properties) {
                return new FieldViolation(properties);
            };

            /**
             * Encodes the specified FieldViolation message. Does not implicitly {@link proto.ValidationError.FieldViolation.verify|verify} messages.
             * @function encode
             * @memberof proto.ValidationError.FieldViolation
             * @static
             * @param {proto.ValidationError.IFieldViolation} message FieldViolation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FieldViolation.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.field != null && message.hasOwnProperty("field"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.field);
                if (message.code != null && message.hasOwnProperty("code"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.code);
                if (message.param != null && message.hasOwnProperty("param"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.param);
                if (message.msg != null && message.hasOwnProperty("msg"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.msg);
                return writer;
            };

            /**
             * Encodes the specified FieldViolation message, length delimited. Does not implicitly {@link proto.ValidationError.FieldViolation.verify|verify} messages.
             * @function encodeDelimited
             * @memberof proto.ValidationError.FieldViolation
             * @static
             * @param {proto.ValidationError.IFieldViolation} message FieldViolation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FieldViolation.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FieldViolation message from the specified reader or buffer.
             * @function decode
             * @memberof proto.ValidationError.FieldViolation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {proto.ValidationError.FieldViolation} FieldViolation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FieldViolation.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.proto.ValidationError.FieldViolation();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.field = reader.string();
                        break;
                    case 2:
                        message.code = reader.string();
                        break;
                    case 3:
                        message.param = reader.string();
                        break;
                    case 4:
                        message.msg = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FieldViolation message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof proto.ValidationError.FieldViolation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {proto.ValidationError.FieldViolation} FieldViolation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FieldViolation.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FieldViolation message.
             * @function verify
             * @memberof proto.ValidationError.FieldViolation
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FieldViolation.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.field != null && message.hasOwnProperty("field"))
                    if (!$util.isString(message.field))
                        return "field: string expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.param != null && message.hasOwnProperty("param"))
                    if (!$util.isString(message.param))
                        return "param: string expected";
                if (message.msg != null && message.hasOwnProperty("msg"))
                    if (!$util.isString(message.msg))
                        return "msg: string expected";
                return null;
            };

            /**
             * Creates a FieldViolation message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof proto.ValidationError.FieldViolation
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {proto.ValidationError.FieldViolation} FieldViolation
             */
            FieldViolation.fromObject = function fromObject(object) {
                if (object instanceof $root.proto.ValidationError.FieldViolation)
                    return object;
                var message = new $root.proto.ValidationError.FieldViolation();
                if (object.field != null)
                    message.field = String(object.field);
                if (object.code != null)
                    message.code = String(object.code);
                if (object.param != null)
                    message.param = String(object.param);
                if (object.msg != null)
                    message.msg = String(object.msg);
                return message;
            };

            /**
             * Creates a plain object from a FieldViolation message. Also converts values to other types if specified.
             * @function toObject
             * @memberof proto.ValidationError.FieldViolation
             * @static
             * @param {proto.ValidationError.FieldViolation} message FieldViolation
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FieldViolation.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.field = "";
                    object.code = "";
                    object.param = "";
                    object.msg = "";
                }
                if (message.field != null && message.hasOwnProperty("field"))
                    object.field = message.field;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.param != null && message.hasOwnProperty("param"))
                    object.param = message.param;
                if (message.msg != null && message.hasOwnProperty("msg"))
                    object.msg = message.msg;
                return object;
            };

            /**
             * Converts this FieldViolation to JSON.
             * @function toJSON
             * @memberof proto.ValidationError.FieldViolation
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FieldViolation.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FieldViolation;
        })();

        return ValidationError;
    })();

    return proto;
})();

module.exports = $root;
